/* import __COLOCATED_TEMPLATE__ from './step-title.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();